import { useEffect, useState } from "react"

export const useScrollFixed = (startId: string, offset: number = 0, endId?: string) => {
  const [isFixed, setIsFixed] = useState(false)

  useEffect(() => {
    if (typeof window === "undefined") return

    const startEl = document.getElementById(startId)
    const endEl = endId ? document.getElementById(endId) : null

    if (!startEl) return

    const calc = () => {
      const startRect = startEl.getBoundingClientRect()
      const startTop = startRect.top + window.scrollY

      const endBottom = endEl ? endEl.getBoundingClientRect().top + window.scrollY + endEl.offsetHeight : Infinity

      return { startTop, endBottom }
    }

    let { startTop, endBottom } = calc()

    const handleScroll = () => {
      const scrollY = window.scrollY

      const shouldFix = scrollY + offset >= startTop && scrollY < endBottom

      setIsFixed(shouldFix)
    }

    const recalc = () => {
      ;({ startTop, endBottom } = calc())
      handleScroll()
    }

    handleScroll()

    window.addEventListener("scroll", handleScroll, { passive: true })
    window.addEventListener("resize", recalc)

    const ro = new ResizeObserver(() => {
      recalc()
    })

    ro.observe(startEl)
    if (endEl) ro.observe(endEl)

    const modules = document.getElementById(endId ?? "")
    if (modules) ro.observe(modules)

    return () => {
      window.removeEventListener("scroll", handleScroll)
      window.removeEventListener("resize", recalc)
      ro.disconnect()
    }
  }, [startId, endId, offset])

  return isFixed
}
